// Types
import {
  INormalizedTennisMatch,
  INormalizedTournamentData,
  ITennisConfig,
  ITennisTournamentProgramme,
  SDKDateOptions,
} from '../../../../packages/types';
import { INormalizedRoundData } from './normalizeTennisRoundData';

// Constants
import { normalizeTournamentData } from '@sportal365/smp-widget-normalizers';
import { Sports } from '../../../../packages/constants/sportType';
import { normalizeTennisProgrammeResponseData } from './normalizeTennisProgrammeData';

interface INormalizeTennisTournamentProgrammeResponseDataArgs {
  programme?: ITennisTournamentProgramme[];
  dataEntityLinks?: ITennisConfig['dataEntityLinks'];
  dataShortStatusType?: ITennisConfig['dataShortStatusType'];
  dataLabels?: ITennisConfig['dataLabels'];
  sdkDateOptions?: SDKDateOptions;
}

type NormalizedTennisTournamentProgrammeResponseData =
  | {
      matches:
        | {
            matches: (void | INormalizedTennisMatch)[];
            round: INormalizedRoundData | undefined;
          }[]
        | undefined;
      tournament: INormalizedTournamentData | undefined;
    }[]
  | undefined;

export const normalizeTennisTournamentProgrammeResponseData = ({
  programme,
  dataLabels,
  dataEntityLinks,
  dataShortStatusType,
  sdkDateOptions,
}: INormalizeTennisTournamentProgrammeResponseDataArgs): NormalizedTennisTournamentProgrammeResponseData => {
  if (!programme || programme?.length < 1) return;
  return programme?.map(({ tournament, matches }) => {
    const normalizedMatches = normalizeTennisProgrammeResponseData({
      matchesList: matches,
      dataLabels,
      dataEntityLinks,
      dataShortStatusType,
      sdkDateOptions,
    });
    const normalizedTournament = normalizeTournamentData({ tournament: tournament, dataEntityLinks, sport: Sports.TENNIS });
    return { matches: normalizedMatches, tournament: normalizedTournament };
  });
};
